import axios from 'axios';
import { PaginatedEvaluationRequestStatus } from './types';

export const getEvaluationsRequestStatuses =
  async (): Promise<PaginatedEvaluationRequestStatus> => {
    return (await axios.get(`/v1/evaluation-request-status`)).data;
  };
